import { prioritizer } from '@yola/subscription-manager-js';

const sortBySubscriptionId = (subscriptionsConfig) =>
  subscriptionsConfig.sort((a, b) => prioritizer.getPriority(a.id) - prioritizer.getPriority(b.id));

export default sortBySubscriptionId;
